<template>
    <div class="flex mt-4 flex-wrap md:flex-nowrap pb-10 md:pb-0">
        <div class="bg-white rounded px-7 pt-7 pb-20 xl:mr-9 md:mr-6 mr-0 shadow-card md:w-auto w-full mb-4 md:mb-0">
            <div class="inline-flex items-center">
                <i
                    class="fas text-xs fa-arrow-left mr-3 cursor-pointer"
                    @click="$emit('go-back')"
                />
                <h4 class="font-medium">Preencha os campos</h4>
            </div>

            <div class="mt-5 xl:w-80 lg:w-64 md:w-60 w-full">
                <div>
                    <jet-label class="text-gray-800" :value="'Valor'" />
                    <div class="relative">
                        <span class="absolute text-xs font-bold left-4 top-4 leading-none">R$</span>
                        <jet-decimal
                            id="amount"
                            type="text"
                            class="mt-1 block w-full text-md"
                            maxlength="11"
                            ref="amount"
                            :value="form.amount"
                            @input="handleInputAmount"
                        />
                        <jet-input-error :message="form.error('amount')" class="mt-1" />
                    </div>
                </div>
                <div class="mt-6">
                    <div class="flex justify-between">
                        <jet-label class="text-gray-800" :value="'Identificador de cobrança'" />
                        <jet-label class="text-gray-300 opacity-60" :value="'Opcional'" />
                    </div>
                    <div class="relative">
                        <jet-input
                            id="identify"
                            type="text"
                            class="mt-1 block w-full text-md"
                            v-model="form.receiver_code"
                            maxLength="40"
                        />
                    </div>
                    <jet-input-error :message="form.error('receiver_code')" class="mt-2" />
                </div>
                <div class="mt-6">
                    <div class="flex justify-between">
                        <jet-label class="text-gray-800" :value="'Descrição'" />
                        <jet-label class="text-gray-300 opacity-60" :value="'Opcional'" />
                    </div>
                    <div class="relative">
                        <jet-textarea
                            class="w-full h-20 rounded-md border border-solid border-black text-gray-700 py-3 px-3 resize-none mt-1"
                            v-model="form.description"
                            maxlength="40"
                        />
                    </div>
                </div>
            </div>
        </div>

        <form-summary
            class="flex-1 md:mb-6 lg:mb-0 mb-0"
            :form="form"
            :favored="favoredFormatted"
            @input="form[$event.type] = $event.value"
            @submit="transferPix"
        />
    </div>
</template>

<script>
import JetInput from "../../../Jetstream/Input.vue";
import JetInputError from "../../../Jetstream/InputError.vue";
import JetDecimal from "../../../Jetstream/Decimal.vue";
import JetLabel from "../../../Jetstream/Label.vue";
import JetTextarea from "../../../Jetstream/Textarea.vue";
import JetDatePicker from "../../../Jetstream/DatePicker.vue";
import moment from 'moment'
import Favored from '../components/Favored.vue';
import FormSummary from "../components/FormSummary.vue";
import { generateRandomColor, getNameInitials } from '../utils/utils';

export default {
    name: 'FormValueDetails',
    props: {
        favored: { type: Object, required: true}
    },
    data(){
        return {
            datePix: new Date(),
            loadingTransaction: false,
            form: this.$inertia.form({
                _method: 'POST',
                amount: 0,
                contact: {
                    name: this.favored.nomeCorrentista,
                    federal_document: this.favored.documentoFederal,
                },
                transfer_type: {
                    name: 'PIX'
                },
                selected_account: {
                    agency: this.favored.conta.agencia,
                    bank: {
                        id: null,
                        name: this.favored.banco.descricao
                    },
                    number: this.favored.banco.numero,
                    key: this.favored.chave,
                    type: 'PIX'
                },
                federal_document: this.favored.documentoFederal,
                goal: {
                    id: 99999,
                    name: "Outros"
                },
                google_code: null,
                receiver_code: null,
                description: null
            })
        }
    },
    computed: {
        favoredFormatted(){
            return {
                ...this.favored,
                key: this.favored.key,
                name: this.favored.nomeCorrentista || this.favored.name,
                initialsName: this.favored.nomeCorrentista
                    ? getNameInitials(this.favored.nomeCorrentista)
                    : this.favored.initialsName,
                bgItemList: this.favored.bgItemList || generateRandomColor(),
                bank: {
                    number: this.favored.banco.numero,
                    description: this.favored.banco.descricao
                },
                account: {
                    account: this.favored.conta.conta,
                    agency: this.favored.conta.agencia
                }
            }
        },
        formatDate(){
            const formatDatePicker = 'dd/MM/yyyy'
            const format = 'DD/MM/YYYY'
            return moment(this.datePix).format(format) === moment().format(format)
                ? formatDatePicker + " \(Hoje\)"
                : formatDatePicker
        },
    },
    methods: {
        handleInputAmount(event = ''){
            this.form.amount = event.replace('-', '')
            if(this.$refs.amount){
                this.$refs.amount.$el.value = this.form.amount
            }
        },
        transferPix(){
            if(this.form.processing) return
            const amount = this.form.amount.replace(".", "").replace(',', '.')
            if (parseFloat(amount) === 0) {
                this.callToast('Informe o valor da operação.', 'error');
                return;
            } else if (!this.form.google_code){
                this.callToast('Informe o código de autorização.', 'error');
                return;
            }

            this.form.post('/transfer', {
                onError: () => {
                    this.form.processing = false
                },
                onSuccess: () => {
                    const contact = {
                        customer: this.form.contact.name,
                        key: this.form.selected_account.key,
                        federal_document: this.form.contact.federal_document,
                        key_type: this.favored.tipoChave
                    }
                    axios.post('/json/pix/recent-transfers', contact)
                }
            });
        },
        callToast(msg, type, temp = 5000) {
            this.$toast.open({
                message: msg,
                type: type,
                duration: temp,
                position: 'top-right'
            });
        }
    },
    components: {
        JetInput,
        JetDecimal,
        JetLabel,
        JetTextarea,
        JetDatePicker,
        JetInputError,
        Favored,
        FormSummary
    }
}
</script>
